import z from "zod";
import { zExt } from "../common/zod-util";

export enum CustomerCustomFieldDataType {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  DATE = "date",
}

export const customerCustomFieldValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.date(),
]);
export type CustomerCustomFieldValue = z.infer<
  typeof customerCustomFieldValueSchema
>;

const base = {
  _id: zExt.objectId(),
  name: z.string(),
  isMultiValued: z.boolean(),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
};

export const customerCustomFieldDeclarationSchema = z.union([
  z.object({
    ...base,
    dataType: z.literal(CustomerCustomFieldDataType.STRING),
    options: z.array(z.string()).nullish(),
  }),
  z.object({
    ...base,
    dataType: z.literal(CustomerCustomFieldDataType.NUMBER),
    options: z.array(z.number()).nullish(),
  }),
  z.object({
    ...base,
    dataType: z.literal(CustomerCustomFieldDataType.BOOLEAN),
    options: z.array(z.boolean()).nullish(),
  }),
  z.object({
    ...base,
    dataType: z.literal(CustomerCustomFieldDataType.DATE),
    options: z.array(z.date()).nullish(),
  }),
]);
export type CustomerCustomFieldDeclaration = z.infer<
  typeof customerCustomFieldDeclarationSchema
>;

export const customerCustomFieldDeclarationSetSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  declarations: z.array(customerCustomFieldDeclarationSchema),
});
/**
 * A schema for defining schemas. The most concrete code ever written.
 * Named a "declaration" as an analogy for declarations in programming (stating something's name and type),
 * and because it avoids naming ambiguity with the terms "schema" and "definition", which already have many meanings in Redo's codebase.
 */
export type CustomerCustomFieldDeclarationSet = z.infer<
  typeof customerCustomFieldDeclarationSetSchema
>;

export const customerCustomFieldInstanceSchema = z.object({
  declarationId: zExt.objectId(),
  dataType: z.enum(CustomerCustomFieldDataType), // never changes, so it's safe and useful to denormalize
  values: z.array(customerCustomFieldValueSchema),
  createdAt: z.date().nullish(),
  updatedAt: z.date().nullish(),
});
export type CustomerCustomFieldInstance = z.infer<
  typeof customerCustomFieldInstanceSchema
>;
